<div class="distribution">
  <div class="info-titlebar">
    Distribution
    @if (!readOnly) {
      <button (click)="saveDistribution()" class="save-button">
        <mat-icon>save</mat-icon>
      </button>
    }
    @if (!readOnly) {
      <button
        class="delete-button"
        (click)="deleteDistribution()">
        <mat-icon>close</mat-icon>
      </button>
    }
  </div>
  <form class="row">
    <div class="col-md-6">
      <label for="distribution_date">Date</label>
      @if (!readOnly) {
        <input
          type="date"
          (change)="handleDistributionChanged()"
          [(ngModel)]="distribution.distribution_date"
          name="distribution_date" />
      }
      <ng-container
        *ngTemplateOutlet="
          readOnly ? valueSpan : nothing;
          context: {
            value: distribution.distribution_date | date: 'MM/dd/yyyy'
          }
        ">
    </ng-container>
  </div>
  <div
    class="col-md-6"
      [class]="{
        is_error:
          distribution.total !== null && distribution.total !== proceedSum
      }">
    <label for="distribution_total">Total</label>
    @if (!readOnly) {
      <input
        type="number"
        (keyup)="handleDistributionChanged()"
        [(ngModel)]="distribution.total"
        name="distribution_total" />
    }
    @if (
      !readOnly &&
      distribution.total !== null &&
      distribution.total !== proceedSum
      ) {
      <span
        class="discrepancy"
        >Total Proceeds: {{ proceedSum | currency }}</span
        >
      }
      <ng-container
        *ngTemplateOutlet="
          readOnly ? valueSpan : nothing;
          context: {
            value: (distribution.total | currency: 'USD':'symbol':'1.0-0')
          }
        ">
    </ng-container>
  </div>
</form>
<div class="row">
  <div class="proceeds">
    <div class="info-titlebar">
      Proceeds
      @if (!readOnly) {
        <button class="add-button" (click)="addProceed()">
          <mat-icon>add</mat-icon>
        </button>
      }
    </div>
    @for (proceed of proceeds; track proceed) {
      <disposition-distribution-proceed
        [readOnly]="readOnly"
        (proceedUpdated)="handleProceedUpdated()"
        [dispositionDistribution]="distribution"
        [proceedList]="proceed">
      </disposition-distribution-proceed>
    }
  </div>
</div>
</div>
<ng-template let-value="value" #valueSpan>
  @if (value?.length) {
    <span class="value">{{ value }}</span>
  } @else {
    <span class="value">&mdash;</span>
  }
</ng-template>
<ng-template #nothing></ng-template>
